import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { hrApi } from '@/api';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import type { HrJobPosting } from '@/types/hr';
import { showApiError } from '@/utils/apiError';
import { notify } from '@/core/toast/notify';

export function HrPublicCareersPage() {
  const { orgId } = useParams<{ orgId: string }>();
  const organizationId = Number(orgId ?? '1');
  const [jobs, setJobs] = useState<HrJobPosting[]>([]);
  const [selectedJob, setSelectedJob] = useState<number | null>(null);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const loadJobs = async () => {
    try {
      setJobs(await hrApi.publicCareersJobs(organizationId));
    } catch (err) {
      showApiError(err, 'Failed to load jobs');
    }
  };

  const apply = async () => {
    if (!selectedJob || !fullName) return;
    try {
      await hrApi.publicCareersApply(organizationId, { jobPostingId: selectedJob, fullName, email, phone });
      notify.success('Application submitted');
      setFullName('');
      setEmail('');
      setPhone('');
    } catch (err) {
      showApiError(err, 'Application failed');
    }
  };

  return (
    <div className="mx-auto max-w-3xl p-6">
      <h1 className="mb-2 text-2xl font-bold">Careers</h1>
      <p className="mb-6 text-slate-600">Browse open positions and apply online.</p>
      <Button variant="secondary" className="mb-4" onClick={() => void loadJobs()}>Load openings</Button>
      <ul className="mb-6 space-y-3">
        {jobs.map((j) => (
          <li key={j.id} className="card cursor-pointer p-4" onClick={() => setSelectedJob(j.id)}>
            <div className="font-semibold">{j.title}</div>
            <div className="text-sm text-slate-500">{j.description?.slice(0, 120)}</div>
          </li>
        ))}
      </ul>
      {selectedJob && (
        <section className="card space-y-3 p-4">
          <h2 className="font-semibold">Apply for job #{selectedJob}</h2>
          <Input label="Full name" value={fullName} onChange={(e) => setFullName(e.target.value)} />
          <Input label="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Input label="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
          <Button onClick={() => void apply()}>Submit application</Button>
        </section>
      )}
    </div>
  );
}
